import { SpecialWidgetTypeEnum } from '@kaltura-ott/tvpil';
import { CollectionRailStoreV2, RailStoreV2 } from '@kaltura-ott/tvpil-shared';

export function checkIsLogoRail(rail: RailStoreV2) {
  return rail instanceof CollectionRailStoreV2 && rail.specialWidgetType === SpecialWidgetTypeEnum.logo;
}
